<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>المناطق</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة منطقة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <!-- <v-text-field v-model="newItem.name" label="المدير المباشر" v-validate="'required'"
                        :error-messages="errors.collect('form1.name')" data-vv-name="name" data-vv-scope="form1" >
                    </v-text-field> -->
                      <v-select
                        v-model="select_mohafza"
                        :items="mohafzas"
                        item-text="name"
                        item-value="id"
                        label="أختر المحافظة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.mohafza')"
                        data-vv-name="mohafza"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم المنطقة"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل منطقة</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_mohafza_edit"
                      :items="mohafzas"
                      item-text="name"
                      item-value="id"
                      label="أختر المحافظة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.mohafza')"
                      data-vv-name="mohafza"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم المنطقة"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="regions"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.mohafza ? props.item.mohafza.name : "" }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="ml-4" @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  regions,
  add_region,
  update_region,
  delete_region
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    select_mohafza: {},
    select_mohafza_edit: {},
    mohafzas: [],
    headers: [
      {
        text: "أسم المنطقة",
        align: "right",
        value: "name"
      },
      {
        text: "المحافظة",
        align: "right",
        value: "name"
      },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    regions: [],
    editedItem: {
      id: "",
      name: "",
      mohafza_id: ""
    },
    newItem: {
      id: "",
      name: "",
      mohafza_id: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      regions().then(response => {
        this.loading = false;
        this.regions = response.data.regions;
        this.mohafzas = response.data.mohafzas;
        this.pagination.totalItems = response.data.regions.length;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.editedIndex = this.regions.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.select_mohafza_edit = {
        id: item.mohafza.id,
        name: item.mohafza.name
      };
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.regions.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_region(frmData2, item.id).then(response => {
            this.loading = false;
            this.regions.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          var frmData = new FormData();
          frmData.append("name", this.newItem.name);
          frmData.append("mohafza_id", this.select_mohafza.id);
          add_region(frmData).then(response => {
            this.regions.push(response.data);
            //  this.newItem.name=''
            //  this.newItem.note=''
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
      //   if (this.editedIndex > -1) {
      //     Object.assign(this.regions[this.editedIndex], this.editedItem)
      //   } else {
      //     this.regions.push(this.editedItem)
      //   }

      // this.close()
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_name = this.editedItem.name;
          let item_note = this.editedItem.note;
          let item_id = this.editedItem.id;
          var frmData = new FormData();
          frmData.append("name", item_name);
          frmData.append("mohafza_id", this.select_mohafza_edit.id);
          update_region(frmData, item_id).then(response => {
            Vue.set(
              this.regions,
              this.regions.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
